/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 02/22/2022
 *
 */

import React, {useEffect, useState} from 'react';
import API from "../../../../../utils/api";
import '../formElement.css';
import AsyncPaginate from "react-select-async-paginate";
import './asyncPaginateStyles.css';

/**
 * functional component for DropdownMultiSelect
 * @param labelName - field label
 * @param valueType - the dropdown type(eg. partner, partnerRoles, basic)
 * @param value - field default value if available
 * @param handleChange
 * @param path - url path for the controller (eg. /partners, /partner-urls)
 * @param optionValueName
 * @param optionLabelName
 * @returns {*}
 * @constructor
 */
const DropdownMultiSelect = ({labelName, valueType, value, handleChange, path, optionValueName, optionLabelName}) => {
    // get user credentials
    const user = JSON.parse(localStorage.getItem('tmcUser'));
    // create token
    const token = 'Bearer ' + user.token;

    // the selected value from the dropdown
    const [selectedValue, setSelectedValue] = useState([]);

    useEffect(() => {
        setSelectedValue(value);
    }, [value]);

    const loadOptions = async (search, loadedOptions, { page }) => {
        // has more data to load
        let hasMore = true;
        // the options in the list
        const options = [];

        if (valueType === 'accountAdminRoles') {
            let url;
            if (search === '') {// check a search or not
                url = process.env.REACT_APP_BASE_URL + path + '/admin-role?page-no=' + page;
            } else {
                url = process.env.REACT_APP_BASE_URL + path + '/admin-role?page-no=' + page + '&search=' + search;
            }

            await API.get(url, {headers: {Authorization: token}})
                .then(res => {
                    const accountAdminRoles = Object.values(res.data);
                    accountAdminRoles.forEach(roleObj => {
                        options.push({
                            value: roleObj.adminRoleId,
                            label: roleObj.adminRoleAuthority,
                            optionValueName: optionValueName,
                            optionLabelName: optionLabelName
                        })
                    });
                })
                .catch(er => {
                    hasMore = false
                });
        }

        return {
            options: options,
            hasMore,

            additional: {
                page: page + 1
            }
        }
    };

    const onChange = selectedOption => {
        handleChange(selectedOption);
        setSelectedValue(selectedOption);
    };

    return(
        <div>
            <label>
                {labelName}
            </label>
            <AsyncPaginate
                value={selectedValue}
                loadOptions={loadOptions}
                isMulti
                closeMenuOnSelect={false}
                onChange={onChange}
                additional={{
                    page: 0,
                }}
            />
        </div>
    );
};

export default DropdownMultiSelect;
